(function ($) {$(function(){
    const $gallery = $('#director-gallery-modal');
    const modalCloseBtn = $('#director-gallery-close');
    const modalOpenBtn = $('#open-director-gallery');
    
    if ($gallery.length) {
        const swiper = new Swiper('.swiper', {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
    modalCloseBtn.on('click', function (e) {
        $gallery.removeClass('active');
    });
    modalOpenBtn.on('click', function (e) {
        e.preventDefault();
        $gallery.addClass('active');
    });

});}(_jQ3));

